import React from 'react'
import {observer} from 'mobx-react'
import MediaThumbnail from '../ProcedureMain/ProcedureMedia/MediaThumbnail'
import * as serverEnums from "../../../serverClientShared/sharedEnums";
import PropTypes from 'prop-types';
import {procedureNodeTypeEnum} from "../../../serverClientShared/sharedEnums";
import ConditionalComponent from "../../Shared/ConditionalComponent";
import {useStores} from "../../../Hooks";
import {getProcedureText, getNodeMedia} from "../../../serverClientShared/sharedUtils";

const SidebarSlide = observer(props => {
    const {procedureStore, generalStore} = useStores();


    const {isPreview, index, node} = props;
    const currentProcedure = isPreview ? procedureStore.currentPreviewedProcedure : procedureStore.currentProcedure;
    const currentNode = (isPreview ? procedureStore.currentPreviewedNode : procedureStore.currentNode) || {};
    let sortedMedia = sortMedia();
    let serialNumber = index + 1;
    if (procedureStore.innerProcedureParentProcedureIds.length) {
        serialNumber++;
    }

    const isSelectionStep = [procedureNodeTypeEnum.MULTI, procedureNodeTypeEnum.QUESTION].includes(node.NodeType);

    function sortMedia() {
        const sortedMedia = {
            img: 0,
            vid: 0,
            pdf: 0
        };
        for (const file of getNodeMedia(currentNode, "NodeMediaFilesRefs", currentProcedure).FileRefs) {
            switch (file.FileType) { // TODO sidebar
                case serverEnums.fileTypeEnum.IMAGE:
                    sortedMedia.img++;
                    break;
                case serverEnums.fileTypeEnum.VIDEO:
                    sortedMedia.vid++;
                    break;
                case serverEnums.fileTypeEnum.PDF:
                    sortedMedia.pdf++;
                    break;
                default:
                    console.log('other');
            }
        }
        return sortedMedia;
    }

    function goToSlide() {
        if (procedureStore.sessionViewerOpen) {
            return;
        }

        if (currentNode && currentNode.WarningPopupIdentifiers && currentNode.WarningPopupIdentifiers.length) {
            for (const nodeId of currentNode.WarningPopupIdentifiers) {
                const popupNode = procedureStore.getNodeById(nodeId, isPreview);
                if (!!popupNode && !popupNode.approved && !!popupNode.RequireConformation) {
                    return
                }
            }
        }

        const allowSkip = currentProcedure?.Settings?.AllowSkipStep;
        if (allowSkip !== undefined && !allowSkip) { // default is true
            return;
        }
        const goToNodeMethod = isPreview ? procedureStore.goToPreviewNode : procedureStore.goToNode;
        goToNodeMethod(node.Identifier);
    }

    return (
        <div className="sidebar-slide-container" onClick={goToSlide}>
            <div className="sidebar-slide-header">
                {serialNumber ? (serialNumber + '.') : ""}&nbsp;<span
                dangerouslySetInnerHTML={{__html: getProcedureText(node, "StepHeader", currentProcedure)}}/>
            </div>
            <div
                className={`sidebar-slide-image-container${node.Identifier === currentNode.Identifier ? " current-slide" : ""}`}>
                {getNodeMedia(currentNode, "NodeMediaFilesRefs", currentProcedure).FileRefs.length
                    ? <MediaThumbnail media={getNodeMedia(currentNode, "NodeMediaFilesRefs", currentProcedure).FileRefs[0]} inSidebar={true}
                                      isPreview={isPreview}/>
                    : <div className="empty-slide"/>
                }
            </div>
            <div className="sidebar-slide-details">
                <div className="sidebar-slide-split-point-container">
                    <ConditionalComponent if={isSelectionStep}>
                        <div className="sidebar-slide-split-point">{generalStore.translate('splitPoint')}</div>
                    </ConditionalComponent>
                </div>
                <div className="sidebar-slide-media-container">
                    {sortedMedia.img > 0
                        ? <div className="sorted-media-img">
                            <i className="far fa-image"/>
                            <span className="slide-media-count">{sortedMedia.img}</span>
                        </div>
                        : null
                    }
                    {sortedMedia.vid > 0
                        ? <div className="sorted-media-vid">
                            <i className="fas fa-video"/>
                            <span className="slide-media-count">{sortedMedia.vid}</span>
                        </div>
                        : null
                    }
                    {sortedMedia.pdf > 0
                        ? <div className="sorted-media-pdf">
                            <i className="far fa-file-pdf"/>
                            <span className="slide-media-count">{sortedMedia.pdf}</span>
                        </div>
                        : null
                    }
                </div>
            </div>
        </div>
    )
});


SidebarSlide.propTypes = {
    isPreview: PropTypes.bool.isRequired
}

export default SidebarSlide
